// Each form owns a verifier. Invalidating it prevents an older response from
// supplying a verification code for a card or member that has since changed.
export function createCardVerifier (request) {
  let revision = 0
  return {
    invalidate () { revision++ },
    verify (cardNo, purpose, isCurrent = () => true) {
      const requestRevision = ++revision
      if (!/^[0-9]{16}$/.test(cardNo)) return Promise.reject(new Error('卡片號碼格式錯誤'))
      return Promise.resolve().then(() => request(cardNo, purpose)).then(response => {
        if (requestRevision !== revision || !isCurrent()) {
          const stale = new Error('卡片資料已變更，請重新驗證')
          stale.stale = true
          throw stale
        }
        const data = response && (response.data || response)
        if (!data) throw new Error('目前無法進行卡片驗證，請稍後再試')
        if (data.error) throw new Error(data.error)
        if (typeof data.CardValidCode !== 'string' || !data.CardValidCode) {
          throw new Error('目前無法進行卡片驗證，請稍後再試')
        }
        return { cardNo, CardValidCode: data.CardValidCode }
      }).catch(error => {
        if (requestRevision !== revision || !isCurrent()) {
          const stale = new Error('卡片資料已變更，請重新驗證')
          stale.stale = true
          throw stale
        }
        if (error.isAxiosError) throw new Error('目前無法進行卡片驗證，請稍後再試')
        throw error
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/cardValidation.js